import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Car } from '../car';
import { Imagemodel } from '../imagemodel';
import { RegistrationService } from '../registration.service';

@Component({
  selector: 'app-table-list',
  templateUrl: './table-list.component.html',
  styleUrls: ['./table-list.component.css']
})
export class TableListComponent implements OnInit {

  cars: Car[] = [];
  imagemodel=new Imagemodel();
  isLoading = false;
  
  constructor(private  _service : RegistrationService, private _route : Router) { }

  ngOnInit(): void {
    // Ensure we start at the top of the page when navigating here
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    this.CarList();
  }


  CarList()
{
  this.isLoading = true;
  this._service.CarListFromRemote().subscribe(data => {
    this.cars = data || [];
    this.isLoading = false;
  }, err => {
    console.error('Error loading cars:', err);
    this.cars = [];
    this.isLoading = false;
  });

}

carDetails(carId: number){
  this._route.navigate(['typography', carId]);
}

updateCar(carId: number){
  this._route.navigate(['upgrade', carId]);
}

deleteCar(carId: number){
  this._service.deleteCar(carId).subscribe( data => {
    console.log(data);
    this.CarList();;
  })
}

getCarImageUrl(imageName: string): string {
  return this._service.getCarImageUrl(imageName);
}

getImage()
 {
  
  this._service.getImageFromRemote(this.imagemodel).subscribe(
    data=> {
      
      this.imagemodel.retrieveResonse = data;
  
      this.imagemodel.base64Data = this.imagemodel.retrieveResonse.picByte;
    
      this.imagemodel.retrievedImage = 'data:image/jpeg;base64,' + this.imagemodel.base64Data;
    
      }

   )
 }



}